import Seo from "@/components/feature/Seo";
import HeroSection from "@/pages/home/components/HeroSection";
import CategoryStrip from "@/pages/home/components/CategoryStrip";
import HotSection from "@/pages/home/components/HotSection";
import DeepSection from "@/pages/home/components/DeepSection";
import LatestSection from "@/pages/home/components/LatestSection";
import TestimonialSection from "@/pages/home/components/TestimonialSection";
import HomeFaqSection from "@/pages/home/components/HomeFaqSection";
import CtaBand from "@/pages/home/components/CtaBand";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "看料吃瓜社",
    url: "https://kanliaochigua.example/",
    inLanguage: "zh-CN",
    description:
      "看料吃瓜社整合热门大瓜、劲爆猛料与深水硬核内容，按时间线整理可追溯的瓜源汇总。",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://kanliaochigua.example/hot?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "看料吃瓜社",
    url: "https://kanliaochigua.example/",
    email: "contact@kanliaochigua.example",
    description:
      "专注娱乐热点与网络舆论话题整理的中文内容站点，坚持标注信息来源与更新时间。",
  },
  {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "看料吃瓜社首页",
    url: "https://kanliaochigua.example/",
    inLanguage: "zh-CN",
    isPartOf: { "@type": "WebSite", name: "看料吃瓜社" },
  },
];

export default function Home() {
  return (
    <>
      <Seo
        title="看料吃瓜社 | 热门大瓜、劲爆猛料与深水硬核内容汇总"
        description="看料吃瓜社汇总看料吃瓜猛料与大瓜，热门话题、劲爆重料、深水硬核内容持续更新，按时间线整理并标注信息来源，一次看够不用东翻西找。"
        keywords="看料吃瓜,看料吃瓜猛料,看料吃瓜大瓜,看料吃瓜劲爆,看料吃瓜重料,看料吃瓜深水,看料吃瓜硬核"
        path="/"
        jsonLd={jsonLd}
      />
      <HeroSection />
      <CategoryStrip />
      <HotSection />
      <DeepSection />
      <LatestSection />
      <TestimonialSection />
      <HomeFaqSection />
      <CtaBand />
    </>
  );
}